import { actionTypes } from '../actions/imi'

const initial = {
	list: [],
  current_page: '',
  last_page: '',
  total: '',
	noteDetail: '',
  imiDetail: '',
  year: '',
  month: '',
  notes: '',
  dates: '',
  sectors: { category_type: [], subsidiary_type: [] },
  loading: false
}

export default (state = initial, action) => {
  switch (action.type) {

  	case actionTypes.RECEIVE_IMIS:
      return Object.assign({}, state, {
        list: action.data.data,
        current_page: action.data.current_page,
        last_page: action.data.last_page,
        total: action.data.total,
        loading: false
    })

    case actionTypes.RECEIVE_NOTE_DETAIL:
      return Object.assign({}, state, {
        noteDetail: action.data
    })

    case actionTypes.SAVE_IMI_DETAIL:
      return Object.assign({}, state, {
        imiDetail: action.data
    })

    case actionTypes.SET_YEAR:
      return Object.assign({}, state, {
        year: action.value
    })

    case actionTypes.SET_MONTH:
      return Object.assign({}, state, {
        month: action.value
    })

    case actionTypes.RECEIVE_FILTERED_IMIS:
      return Object.assign({}, state, {
        list: action.data.data,
        current_page: action.data.current_page,
        last_page: action.data.last_page,
        loading: false
    })

    case actionTypes.RECEIVE_NOTES:
      return Object.assign({}, state, {
        notes: action.data
    })

    case actionTypes.RECEIVE_DATES:
      return Object.assign({}, state, {
        dates: action.data
    })

    case actionTypes.RECEIVE_SECTORS:
      return Object.assign({}, state, {
        sectors: action.data
    })

    case actionTypes.LOADING_IMIS:
      return Object.assign({}, state, {
        loading: true
      })

  	default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/imi.js